import { render, staticRenderFns } from "./CardSettings.vue?vue&type=template&id=011a1276&"
import script from "./CardSettings.vue?vue&type=script&lang=js&"
export * from "./CardSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports